"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { PersistOptions } from "zustand/middleware";

interface UserSettingState {
  selectedFontSize: FontSize;
  selectedFont: font;
  selectedLineHeight: Lineheight;
  selectedFontSizePanel: FontSize;
  selectedLineHeightPanel: Lineheight;
  typeWriter: boolean;
  goalTime: number; // 타이머 목표 시간 (분)
  inactivityThreshold: number; // 비활동 임계값 (초)
  mode: string; // 타이머 모드 ("focusedTime" 또는 "remaining")
  selectedDevice: Device; // 선택된 디바이스 (단일 객체)
  setSelectedFontSize: (fontsize: FontSize) => void;
  setSelectedFont: (font: font) => void;
  setLineHeight: (Lineheight: Lineheight) => void;
  setSelectedFontSizePanel: (fontsize: FontSize) => void;
  setLineHeightPanel: (Lineheight: Lineheight) => void;
  setTypeWriter: (typeWriter: boolean) => void;
  setGoalTime: (goalTime: number) => void;
  setInactivityThreshold: (inactivityThreshold: number) => void;
  setMode: (mode: string) => void;
  setSelectedDevice: (device: Device) => void; // 선택된 디바이스 설정
}

const userSettingStore = create<UserSettingState>()(
  persist(
    (set) => ({
      selectedFontSize: { name: "Base", size: "18px" },
      selectedFont: { name: "프리텐다드", family: "var(--font-pr)" },
      selectedLineHeight: { label: "100%", size: 1.8 },
      selectedFontSizePanel: { name: "Small", size: "16px" },
      selectedLineHeightPanel: { label: "60%", size: 1.08 },
      typeWriter: false,
      goalTime: 25,
      inactivityThreshold: 10,
      mode: "focusedTime",
      selectedDevice: { label: "Desktop", width: "95%", height: "100%" },
      setSelectedFontSize(fontsize) {
        set({ selectedFontSize: fontsize });
      },
      setSelectedFont: (font) => set({ selectedFont: font }),
      setLineHeight: (lineheight) => set({ selectedLineHeight: lineheight }),
      setSelectedFontSizePanel(fontsize) {
        set({ selectedFontSizePanel: fontsize });
      },
      setLineHeightPanel: (lineheight) =>
        set({ selectedLineHeightPanel: lineheight }),
      setTypeWriter: (typeWriter) => set({ typeWriter }),
      setGoalTime: (goalTime) => set({ goalTime }),
      setInactivityThreshold: (inactivityThreshold) =>
        set({ inactivityThreshold }),
      setMode: (mode) => set({ mode }),
      setSelectedDevice: (device) => set({ selectedDevice: device }),
    }),
    {
      name: "settings-storage",
      getStorage: () => localStorage,
    } as PersistOptions<UserSettingState>,
  ),
);

export default userSettingStore;
